/**
 * Current Questionnaire follows this structure. This exists as a reference for components; can be used to set the state to this later.
 * Null as a string for rendering purposes; I am not stupid.
 */

export const Schema = {
    intro: {
        companyName: null,
        problemStatement: null,
        problemSolution: null
    },
    purpose: {
        passion: {
            thingsThatMadeYouProud: [
                {
                    proud: 'NULL'
                },
            ],
            emergedFromCases: 'NULL',
            emergedFromSentence: 'NULL'
        },
        people: {
            people1: [
                {
                    people: 'People'
                },
                {
                    people: 'People'
                },
                {
                    people: 'People'
                },
                {
                    people: 'People'
                },
            ],
            people2: [
                {
                    target: 'Target'
                },
                {
                    target: 'Target'
                },
                {
                    target: 'Target'
                },
                {
                    target: 'Target'
                },
            ],
            combine: 'Combine',
        },
        impact: {
            impactBenefit1: [
                {
                    impactBenefit: 'NULL'
                },
                {
                    impactBenefit: 'NULL'
                },
                {
                    impactBenefit: 'NULL'
                },
                {
                    impactBenefit: 'NULL'
                },
            ],
            impactBenefit2: [
                {
                    impactBenefit: 'NULL'
                },
                {
                    impactBenefit: 'NULL'
                },
                {
                    impactBenefit: 'NULL'
                },
                {
                    impactBenefit: 'NULL'
                },
            ],
            combine: 'NULL'
        },
        product: {
            productService1: [
                {
                    productService: 'NULL'
                },
                {
                    productService: 'NULL'
                },
                {
                    productService: 'NULL'
                },
                {
                    productService: 'NULL'
                },
            ],
            combine: 'NULL'
        }
    },
    vision: {
        companyPotential: [
            {
                companyPotential: 'NULL'
            }
        ],
        worldPotential: 'NULL'
    },
    personality: {
        values: {
            personalityValues: [
                {
                    personalityValue: '',
                }
            ]
        },
        look: {
            allLookAndFeelAttributes: [
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
            ],
            fiveLookAndFeelAttributes: [
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
            ],
            threeLookAndFeelAttributes: [
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
                {
                    lookAndFeelAttribute: "",
                },
            ],
            companiesThatLookLikeThat1: [
                {
                    company: "",
                },
                {
                    company: "",
                },
            ],
            companiesThatLookLikeThat2: [
                {
                    company: "",
                },
                {
                    company: "",
                },
            ],
        },
        tone: {
            allToneAttributes: [
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                }
            ],
            fiveToneAttributes: [
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                }
            ],
            threeToneAttributes: [
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                },
                {
                    toneAttribute: '',
                }
            ],
            companiesThatSoundLikeThat: [
                {
                    companyThatSoundsLikeThat: '',
                },
                {
                    companyThatSoundsLikeThat: '',
                }
            ],
            peopleThatSoundLikeThat: [
                {
                    peopleThatSoundLikeThat: ''
                },
                {
                    peopleThatSoundLikeThat: ''
                }
            ],
        },
        attributes: {
            personalityAttributes: [
                {
                    leftAttribute: '',
                    personalityAttribute: 4,
                    rightAttribute: ''
                }
            ]
        }
    },
    relationships: {
        competition: [
            {
                attributes: ['Attribute 1', 'Attribute 2', 'Attribute 3', 'Attribute 4'],
                labels: ['Your Company Now', 'Your Aim'],
                positions: [
                    {
                        x: 0,
                        y:0
                    },
                    {
                        x: 4,
                        y: 5
                    }
                ]
            }
        ]
    }
}